<template>
  <v-card-text class="py-3">
    <div v-if="milkTemp" class="d-flex align-center justify-center">
      <div>修正前：</div>
      <v-chip color="milk" class="mr-2" variant="outlined" size="x-small">ミルク</v-chip>
      <div class="">{{ formatTime(milkTemp.recordedAt) }}</div>
    </div>
    <div v-if="milkTemp" class="d-flex align-center justify-center mb-5">
      <div class="ml-4">{{ milkTemp.amount ? milkTemp.amount.value + 'cc' : '不明' }}</div>
      <div class="ml-4" v-if="milkTemp.milkCategory == 'formula'">粉ミルク</div>
      <div class="ml-4" v-if="milkTemp.milkCategory == 'breast'">母乳</div>
    </div>
    <v-menu
      v-model="isRecordetAtPicker"
      :close-on-content-click="false"
      location="bottom start"
      transition="scale-transition"
      min-width="290px"
      max-width="290px"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="localRecordedAt"
          label="時間"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          color="primary"
        ></v-text-field>
      </template>

      <v-time-picker
        v-if="isRecordetAtPicker"
        v-model="localRecordedAt"
        format="24hr"
        locale="ja"
        :allowed-minutes="allowedStep"
        @update:model-value="onTimePicked"
        color="primary"
        @keydown.capture.prevent
      ></v-time-picker>
    </v-menu>

    <div class="d-flex align-baseline">
      <v-select
        :model-value="amount"
        @update:model-value="onChangeAmount"
        :items="milkChoice"
        item-title="value"
        item-value="id"
        label="量"
        variant="outlined"
        density="compact"
      ></v-select>
      <p class="ml-1 body-1">cc</p>
    </div>

    <div class="d-flex align-baseline">
      <v-select
        :model-value="milkCategory"
        @update:model-value="onChangeMilkCategory"
        :items="options"
        item-title="text"
        item-value="value"
        :rules="[rules.required]"
        label="ミルク"
        variant="outlined"
        density="compact"
      ></v-select>
    </div>
  </v-card-text>
</template>
<script lang="ts">
import Vue, { PropType,defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

// model
// import { VForm } from '@/model/vuetify/VForm';
import { MilkResponse, NurseryMilkResponse } from 'chaild-api/lib';
import { diaryReportModule } from '@/store/dataModules/diaryReportModule';
import { MilkChoicesResponse } from '@/model/Response';

export default defineComponent({
  name: 'MilkModal',

  emits: ['update:recordedAt', 'update:amount', 'update:milkCategory'],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
    milkTemp: {
      type: Object as PropType<NurseryMilkResponse>,
    },
    recordedAt: {
      type: String,
      default: '',
    },
    amount: {
      type: Number,
      default: null,
    },
    milkCategory: {
      type: String,
      default: 'breast',
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form() {
      return (this.$refs as any).post_milk_form;
    },
    milkChoice() {
      return diaryReportModule.milkChoice;
    },
    options() {
      const options = [
        { value: 'breast', text: '母乳' },
        { value: 'formula', text: 'ミルク' },
      ];
      return options;
    },
  },

  watch: {
    isOpen: {
      handler(val: boolean) {
        if (val) {
          // amountは親から管理されるため、ここではリセットしない
        }
      },
      deep: true,
    },
    recordedAt(newVal) {
      if (newVal) {
        this.localRecordedAt = dayjs(newVal).format('HH:mm');
      } else {
        this.localRecordedAt = '';
      }
    },
  },

  data: () => ({
    btnLoading: false,
    isRecordetAtPicker: false,
    localRecordedAt: '',
  }),

  methods: {
    showTextMilkType(type: string) {
      const find = this.options.find(option => option.value === type);
      if (find) {
        return find.text;
      }
      return null;
    },
    allowedStep: (m: any) => m % 5 === 0,
    onTimePicked(newTime: string | null) {
      if (!newTime) return;
      this.localRecordedAt = newTime;
      const [hour, minute] = newTime.split(':');
      const iso = dayjs().hour(Number(hour)).minute(Number(minute)).second(0).millisecond(0).toISOString();
      this.$emit('update:recordedAt', iso);
      this.isRecordetAtPicker = false;
    },
    onChangeAmount(newAmount: number) {
      this.$emit('update:amount', newAmount);
    },
    onChangeMilkCategory(newCategory: string) {
      this.$emit('update:milkCategory', newCategory);
    },
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
  },
  mounted() {
    if (this.recordedAt) {
      this.localRecordedAt = dayjs(this.recordedAt).format('HH:mm');
    }
  },
});
</script>
<style lang="scss" scoped></style>
